<template>
  <b-overlay
      :show="$store.getters['slsTemplateImagem/getIsLoading']"
      rounded="sm"
  >
    <div class="position-absolute" style="top: -50px;right: 0">
      <b-button variant="outline-primary" class="mr-2" :to="{name: 'template-imagem-list'}">Cancelar</b-button>
      <b-button
          variant="primary"
          @click="handleSubmit"
      >
        {{ isEditarForm ? 'Editar' : 'Salvar' }}
      </b-button>
    </div>
    <validation-observer ref="refFormEditImagemHome">
      <b-form>
        <b-row>
          <b-col cols="12">
            <b-card>
              <b-card-title class="bg-gray">
                <span>Cadastro de configurações imagens produtos</span>
              </b-card-title>
              <b-row>
                <!-- Tabela: hbi_es_marca -->
                <b-col cols="12" sm="6">
                  <b-form-group label="Marca">
                    <validation-provider
                        #default="{ errors }"
                        name="Marca"
                        rules="required"
                    >
                      <b-form-select
                          v-model="formTemplateImagem.cod_marca"
                          label-field="text"
                          :state="errors.length > 0 ? false:null"
                          value-field="value"
                          :options="$store.getters['slsTemplateImagem/getOptionsMarcas']"
                          @change="changeSelectedMarca($event)"
                          :disabled="isEditarForm"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>

                <!-- Tabela: sls_familia_comercial -->
                <b-col cols="12" sm="6">
                  <b-form-group label="Referência">
                    <validation-provider
                        #default="{ errors }"
                        name="Referência"
                        rules="required"
                    >
                      <v-select
                          id="select-referencia"
                          name="select-referencia"
                          v-model="formTemplateImagem.familia_comercial"
                          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                          :class="{ 'border-danger border-round': errors.length > 0 }"
                          :options="$store.getters['slsTemplateImagem/getOptionsReferencias']"
                          label="descricao"
                          key="descricao"
                          :disabled="formTemplateImagem.cod_marca === null || isEditarForm"
                          :loading="$store.getters['slsTemplateImagem/getIsLoading']"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>

                <b-col cols="12">
                  <b-form-group label="Descrição">
                    <validation-provider
                        #default="{ errors }"
                        name="Descrição"
                    >
                      <b-form-textarea
                          id="textarea-descricao"
                          placeholder="Descrição"
                          :state="errors.length > 0 ? false:null"
                          v-model="formTemplateImagem.descricao"
                          rows="3"
                          :disabled="isEditarForm"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col cols="12" class="mt-2">
                  <b-form-group label="Característica">
                    <validation-provider
                        #default="{ errors }"
                        name="Característica"
                    >
                      <b-form-textarea
                          v-model="formTemplateImagem.caracteristica"
                          :state="errors.length > 0 ? false:null"
                          id="textarea-caracteristica"
                          placeholder="Característica"
                          rows="3"
                          :disabled="isEditarForm"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>

                <b-col cols="12" class="mt-2">
                  <b-form-group label="Composição">
                    <validation-provider
                        #default="{ errors }"
                        name="Composição"
                    >
                      <b-form-textarea
                          v-model="formTemplateImagem.composicao"
                          :state="errors.length > 0 ? false:null"
                          id="textarea-composicao"
                          placeholder="Composição"
                          rows="3"
                          :disabled="isEditarForm"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>

                <b-col cols="12" class="mt-2">
                  <b-form-group label="Benefícios">
                    <validation-provider
                        #default="{ errors }"
                        name="Benefícios"
                    >
                      <b-form-textarea
                          v-model="formTemplateImagem.beneficios"
                          :state="errors.length > 0 ? false:null"
                          id="textarea-beneficios"
                          placeholder="Benefícios"
                          rows="3"
                          :disabled="isEditarForm"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>

                <b-col cols="12" class="mt-2">
                  <b-form-group label="Indicações">
                    <validation-provider
                        #default="{ errors }"
                        name="Indicações"
                    >
                      <b-form-textarea
                          v-model="formTemplateImagem.indicacoes"
                          :state="errors.length > 0 ? false:null"
                          id="textarea-indicacoes"
                          placeholder="Indicações"
                          rows="3"
                          :disabled="isEditarForm"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-card>
          </b-col>

          <b-col cols="12">
            <b-overlay
              :show="isEditarForm"
              opacity="0.80"
            >
            <template #overlay>
              <div class="text-center">
                <h4>
                  Habilite a edição para visualizar
                </h4>
              </div>
            </template>
            <b-card>
              <b-card-title class="d-flex justify-content-between">
                <span>Imagens</span>
                <b-button
                    title="Adicionar imagem"
                    v-b-modal.modal-config-imagem
                    variant="outline-primary"
                    class="btn-icon rounded-circle"
                    :disabled="!formTemplateImagem.cod_marca || isEditarForm"
                >
                  <feather-icon
                      icon="PlusIcon"
                      size="20"
                  />
                </b-button>
              </b-card-title>
              <b-row>
                <b-col cols="12">
                  <b-table
                      :items="imagensTemplateImagem"
                      :fields="columnsTable"
                      :current-page="paginationImagens.currentPage"
                      :per-page="paginationImagens.perPage"
                      responsive
                      class="mb-0"
                  >
                    <template #cell(cdn_cor)="data">
                      <span>{{ data.value }}</span>
                    </template>
                    <template #cell(des_marca)="data">
                      <span>{{ data.value }}</span>
                    </template>
                    <template #cell(des_cor)="data">
                      <span>{{ data.item.des_cor }}</span>
                    </template>
                    <template #cell(caminho)="data">
                      <img
                          v-if="data.item.caminho_base64"
                          :src="data.item.caminho_base64"
                          alt="Imagem"
                          width="100px"
                      />
                      <img
                          v-else-if="data.item.caminho"
                          :src="data.item.caminho"
                          alt="Imagem"
                          width="100px"
                      />
                      <img v-else
                           :src="imagemPadrao"
                           alt="Imagem"
                           width="100px"
                      />
                    </template>
                    <template #cell(cdn_embalag)="data">
                      <span>{{ data.value }}</span>
                    </template>
                    <template #cell(des_embalag)="data">
                      <span>{{ data.value }}</span>
                    </template>
                    <template #cell(exibe_cores)="data">
                      <b-badge
                          v-if="data.value"
                          variant="success"
                      >
                        Sim
                      </b-badge>
                      <b-badge
                          v-else
                          variant="danger"
                      >
                        Não
                      </b-badge>
                    </template>
                    <template #cell(imagem_principal)="data">
                      <b-badge
                          v-if="data.value"
                          variant="success"
                      >
                        Sim
                      </b-badge>
                      <b-badge
                          v-else
                          variant="danger"
                      >
                        Não
                      </b-badge>
                    </template>
                    <template #cell(actions)="data">
                      <div class="d-flex">
                        <b-button
                            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                            title="Visualizar"
                            v-b-modal.modal-config-imagem
                            @click="visualizarImagem(data.item)"
                            :disabled="isEditarForm"
                            variant="flat-success"
                            class="btn-icon"
                        >
                          <feather-icon
                              icon="EyeIcon"
                              size="20"
                          />
                        </b-button>

                        <b-button
                            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                            title="Deletar"
                            variant="flat-danger"
                            @click="deleteImagem(data.index)"
                            class="btn-icon"
                            :disabled="isEditarForm"
                        >
                          <feather-icon
                              icon="TrashIcon"
                              size="20"
                          />
                        </b-button>
                      </div>
                    </template>
                  </b-table>
                </b-col>
                <b-col cols="12" class="d-flex justify-content-end">
                  <b-pagination
                  v-model="paginationImagens.currentPage"
                  :total-rows="formTemplateImagem.imagens.length"
                  :per-page="paginationImagens.perPage"
                  @input="changePaginationImagens"
                  ></b-pagination>
                </b-col>

              </b-row>
            </b-card>
          </b-overlay>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>

    <modal-edit-configuracao-imagem
        ref="refModalConfigImagem"
        v-model="currentImage"
        @addImagem="addOrUpdatedImagem($event)"
        @closeModal="resetCurrentImagen()"
    />
  </b-overlay>
</template>

<script>
import {
  required, email, confirmed, url, between, alpha, integer, password, min, digits, alphaDash, length,
} from '@validations';
import SlsTemplateImagemService from '@/services/SistemaDKP/sls-template-imagem.service';
import ModalEditConfiguracaoImagem from '@/views/cadastros/template-imagem/edit/ModalEditConfiguracaoImagem.vue';
import { generateId } from '@core/utils/utils';
import ToastificationContent from '@/@core/components/toastification/ToastificationContent.vue';
import { IMAGEM_PADRAO } from '@/utils/imagemUrl';

const SLSTemplateImagemService = new SlsTemplateImagemService();
export default {
  name: 'EditIndex',
  components: {
    ModalEditConfiguracaoImagem,
  },
  data() {
    return {
      imagemPadrao: IMAGEM_PADRAO,
      isEditarForm: true,
      paginationImagens: {
        currentPage: 1,
        perPage: 5,
      },
      required,
      email,
      confirmed,
      url,
      between,
      alpha,
      integer,
      password,
      min,
      digits,
      alphaDash,
      length,
      SLSTemplateImagemService,
      columnsTable: [
        { key: 'caminho', label: 'Image', sortable: true },
        { key: 'cdn_cor', label: 'Cód. Cor', sortable: true },
        { key: 'des_cor', label: 'Desc. Cor', sortable: true },
        { key: 'des_marca', label: 'Desc. Marca', sortable: true },
        { key: 'cdn_embalag', label: 'Código Embalagem', sortable: true },
        { key: 'des_embalag', label: 'Desc. Embalagem', sortable: true },
        { key: 'exibe_cores', label: 'Exibe Cor', sortable: true },
        { key: 'imagem_principal', label: 'Imagem Principal', sortable: true },
        { key: 'ordem', label: 'Ordem', sortable: true },
        { key: 'actions', label: 'Ações', sortable: false },
      ],
      currentImage: {
        cdn_cor: null,
        cdn_embalag: null,
        exibe_cores: null,
        des_marca: null,
        imagem_principal: null,
        caminho: null,
        caminho_base64: null,
        ordem: null,
      },
    };
  },
  computed: {
    isAbilityButtonAddImg() {
      return this.$store.getters['slsTemplateImagem/getIsValidCurrentCofigImagem'];
    },
    formTemplateImagem: {
      get() {
        return this.$store.getters['slsTemplateImagem/getCurrentTemplateImagem'];
      },
      set(value) {
        this.$store.commit('slsTemplateImagem/setCurrentTemplateImagem', value);
      },
    },
    imagensTemplateImagem: {
      get() {
        return this.$store.getters['slsTemplateImagem/getImagensCurrentTemplateImagem'];
      },
      set(value) {
        this.$store.commit('slsTemplateImagem/setImagensCurrentTemplateImagem', value);
      },
    },
  },
  methods: {
    showToast(variant, position, timeout) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: 'Atenção!',
          icon: 'InfoIcon',
          text: 'As alterações só serão salvas após clicar no botão Salvar.',
          variant,
        },
      },
      {
        position,
        timeout,
      });
    },
    deleteImagem(index) {
      const globalIndex = (this.paginationImagens.currentPage - 1) * this.paginationImagens.perPage + index;
      const imagemToDelete = this.formTemplateImagem.imagens[globalIndex];

      if (imagemToDelete.log_img_id) {
        this.$store.commit('slsTemplateImagem/addImagemDeletada', imagemToDelete.log_img_id);
      }

      this.formTemplateImagem.imagens.splice(globalIndex, 1);
    },
    isValidURL(string) {
      if (string.startsWith('http://') || string.startsWith('https://')) {
        try {
          new URL(string);
          return true;
        } catch (_) {
          return false;
        }
      }
      return string.startsWith('/');
    },
    blobToBase64(blob) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onerror = reject;
        reader.onload = () => resolve(reader.result);
        reader.readAsDataURL(blob);
      });
    },
    async fetchImageAsFile(imagePath) {
      try {
        if (!this.isValidURL(imagePath)) {
          throw new Error('O caminho da imagem não é válido.');
        }

        const fullUrl = imagePath.startsWith('http')
          ? imagePath
          : `${window.location.origin}${imagePath}`;

        const response = await fetch(fullUrl);
        if (!response.ok) {
          throw new Error(`Erro ao obter a imagem: ${response.statusText}`);
        }
        const blob = await response.blob();

        if (blob.size === 0) {
          throw new Error('O blob da imagem está vazio.');
        }

        const file = new File([blob], 'image.png', { type: 'image/png' });

        if (file.size === 0) {
          throw new Error('O arquivo da imagem está vazio.');
        }

        const base64 = await this.blobToBase64(blob);
        return { file, base64 };
      } catch (error) {
        console.error('Erro ao processar imagem:', error);
        throw error;
      }
    },
    async visualizarImagem(imagem) {
      try {
        let urlImagem;

        if (imagem.caminho.startsWith('https://dkpsales-novo-hanes.s3.amazonaws.com')) {
          urlImagem = imagem.caminho;
        } else if (imagem.caminho.startsWith('http')) {
          urlImagem = imagem.caminho;
        } else {
          urlImagem = `${window.location.origin}${imagem.caminho}`;
        }

        const dataImagem = await this.fetchImageAsFile(urlImagem);

        this.currentImage = {
          ...imagem,
          des_marca: this.$store.getters['slsTemplateImagem/getOptionsMarcas']
            .find((m) => m.value === this.formTemplateImagem.cod_marca)?.text,
          caminho_base64: imagem.caminho,
          caminho: dataImagem.file,
        };
      } catch (error) {
        console.error('Erro ao visualizar imagem:', error);
        console.log('ERRO: ', this.currentImage);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Erro ao carregar a imagem.',
            text: 'Tente novamente ou aguarde a imagem ser cadastrada no sistema.',
            icon: 'AlertTriangleIcon',
            variant: 'warning',
          },
        });
      }
    },
    changePaginationImagens() {
      const start = (this.paginationImagens.currentPage - 1) * this.paginationImagens.perPage;
      const end = start + this.paginationImagens.perPage;
      return this.formTemplateImagem.imagens.slice(start, end);
    },
    changeSelectedMarca() {
      console.log('this.formTemplateImagem.cod_marca', this.$store.getters['slsTemplateImagem/getCurrentTemplateImagem']);
      if (!this.formTemplateImagem.cod_marca) {
        return;
      }
      SLSTemplateImagemService.loadFamiliaComercial(this.$store.getters['slsTemplateImagem/getCurrentTemplateImagem'].cod_marca);
    },
    handleSubmit() {
      if (this.isEditarForm) {
        this.isEditarForm = false;
        return;
      }
      this.$refs.refFormEditImagemHome.validate().then(async (valid) => {
        if (valid) {
          await this.$refs.refFormEditImagemHome.reset();

          const payload = {
            ...this.formTemplateImagem,
            imagensDeletadas: this.$store.getters['slsTemplateImagem/getImagensDeletadas'],
          };
          await SLSTemplateImagemService.updatedImagens(payload);

          this.$store.commit('slsTemplateImagem/initImagensDeletadas');

          await this.$router.push({ name: 'template-imagem-list' });
        }
      });
    },
    changeImg(event, nameVar) {
      const file = event.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.imagemPresenter[nameVar] = e.target.result;
        };
        reader.readAsDataURL(file);
      }
    },
    addOrUpdatedImagem(imagem) {
      const index = this.formTemplateImagem.imagens.findIndex((i) => i.log_img_id === imagem.log_img_id);
      if (index !== -1) {
        this.$store.commit('slsTemplateImagem/updateImagem', { index, imagem });
      } else {
        this.$store.commit('slsTemplateImagem/addImagem', {
          id: generateId(),
          ...imagem,
        });
      }
      this.resetCurrentImagen();
    },
    resetCurrentImagen() {
      this.currentImage = {
        cdn_cor: null,
        cdn_embalag: null,
        exibe_cores: null,
        des_marca: null,
        imagem_principal: null,
        caminho: null,
        caminho_base64: null,
        ordem: null,
      };
    },
  },
  async mounted() {
    this.showToast('info', 'top-center', 8000);

    await SLSTemplateImagemService.loadRecursos();
    await this.$refs.refFormEditImagemHome.reset();
    if (typeof this.$route.params.familiaComercialId !== 'undefined' && typeof this.$route.params.cdnMarca !== 'undefined') {
      await SLSTemplateImagemService.loadConfigImagensByMarcaFamiliaComercial(this.$route.params.cdnMarca, this.$route.params.familiaComercialId);
      const dataTemplateImagen = this.$store.getters['slsTemplateImagem/getTemplateImagem'];
      this.formTemplateImagem = {
        ...dataTemplateImagen,
        familia_comercial: {
          familia_comercial_id: dataTemplateImagen.familia_comercial_id,
          descricao: dataTemplateImagen.familia_comercial_descricao,
          disabled: true,
        },
      };
      this.changeSelectedMarca();
    }
  },
};
</script>

<style scoped lang="scss">
.molde-img {
  border: 2px solid #ccc;
  display: flex;
  justify-content: center;

  img {
    padding: 10px;
    height: 100%;
    width: 100%;
  }
}

.box-img-empty {
  border: 2px solid #ccc;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 300px;
  width: 400px;

  img {
    padding: 10px;
    max-height: 300px;
  }
}

.box-img-empty-primary-secondary {
  border: 2px solid #ccc;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100px;
  width: 250px;

  img {
    padding: 10px;
    max-height: 100px;
    max-width: 250px;
  }
}

</style>
